module.exports = __webpack_public_path__ + "media/images/features/5/og-image-bb09cb89cda31600f1862d82365e6a50.jpg";